import { createContext, use } from "react";
import type { RootStore } from "@/stores/RootStore";

const StoreContext = createContext<RootStore | null>(null);
const StoreProvider = StoreContext.Provider;

const useStore = (): RootStore => {
  const store = use(StoreContext);
  if (!store) {
    throw new Error("useStore must be used within a StoreProvider");
  }

  return store;
};

export { useStore, StoreContext, StoreProvider };
